import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Shop } from '@services/shops/shop.model';
import { TrackingPageService } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/tracking-page.service';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { currencyUnitsToCurrencySymbolMap } from '@pdqdev/pdq-shared/dist/utils/currency-utils';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'tracking-page-metrics',
  templateUrl: './tracking-page-metrics.component.html',
  styleUrls: ['./tracking-page-metrics.component.scss'],
  standalone: false,
})
export class TrackingPageMetricsComponent implements OnInit, OnChanges {
  @Input() shop: Shop;
  @Input() trackingPageMetrics: ShopPlugin.TrackingPage.Metrics = {};
  @Input() isTrackingPageLoading = false;

  metrics: {
    value: string;
    title: string;
    suffix: string;
    prefix: string;
  }[] = [];

  supportedMetrics: { prop: string; title: string }[] = [
    {
      prop: 'totalRevenue',
      title: 'Total revenue',
    },
    {
      prop: 'visits',
      title: 'Visits',
    },
    {
      prop: 'avgViewPerOrder',
      title: 'Avg views per order',
    },
    {
      prop: 'totalShipmentsNum',
      title: 'Total # of shipments',
    },
    {
      prop: 'stuckInTransitNum',
      title: 'Orders stuck in transit',
    },
    {
      prop: 'failuresNum',
      title: 'Orders failures',
    },
  ];

  constructor(
    private trackingPageService: TrackingPageService,
    private decimalPipe: DecimalPipe,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.trackingPageMetrics || changes.shop) {
      this.initMetrics();
    }
  }

  ngOnInit() {
    this.initMetrics();
  }

  private createSuffixOrPrefix(metric: ShopPlugin.TrackingPage.Metric) {
    let suffix = '';
    let prefix = '';
    let value = metric.value;
    switch (metric.type) {
      case 'percentage':
        suffix = '%';
        break;
      case 'currency':
        prefix = currencyUnitsToCurrencySymbolMap[this.shop?.metadata?.currency];
        value = this.decimalPipe.transform(value, '1.0-0');
        break;
      case 'number':
        value = this.decimalPipe.transform(value, '1.0-2');
        break;
      case 'shortThousands':
        value = +value > 1000 ? `${+value / 1000}` : value;
        suffix = 'k';
        break;
      default:
        value = this.decimalPipe.transform(value, '1.0-0');
        break;
    }
    return { suffix, prefix, value: value };
  }

  private initMetrics() {
    this.metrics = this.supportedMetrics
      .filter((metric) => this.trackingPageMetrics[metric.prop])
      .map((metric) => {
        return {
          title: metric.title,
          ...this.createSuffixOrPrefix(this.trackingPageMetrics[metric.prop]),
        };
      });
  }
}
